var map = {
	"./bao-cao-thong-ke-icon.svg": "1113",
	"./danh-gia-khao-sat-icon.svg": "c3f4",
	"./danh-muc-icon.svg": "40fcc",
	"./gia-han-ho-so-icon.svg": "26c4",
	"./nhan-ket-qua-icon.svg": "82e8",
	"./nhat-ki-he-thong-icon.svg": "2011",
	"./phan-quyen-icon.svg": "4c1d",
	"./quy-trinh-icon.svg": "3d78",
	"./thu-phi-icon.svg": "fb1f",
	"./thu-tuc-hanh-chinh-icon.svg": "6508",
	"./tien-ich-icon.svg": "6267",
	"./tiep-nhan-ho-so-icon.svg": "63ee",
	"./tra-cuu-icon.svg": "de7d",
	"./tra-ket-qua-icon.svg": "4933",
	"./trang-chu-icon.svg": "a4c8",
	"./xu-ly-ho-so-icon.svg": "25d0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0f1d";